/**
 * Responsive card grid for landing sections.
 *
 * What: A CSS grid container that takes a per-breakpoint column count and equalizes card heights row by row.
 * Why: Replaces ad-hoc flex-wrap and Stack-with-row layouts that broke when item counts grew (e.g. 6+ items collapsing into one cramped row).
 * When: Update when the canonical card-grid gap or breakpoint scheme changes.
 */
import type { ReactNode } from 'react';
import { Box } from '@mui/material';

interface LandingCardGridProps {
  columns: { xs?: number; sm?: number; md?: number; lg?: number };
  children: ReactNode;
}

function LandingCardGrid({ columns, children }: LandingCardGridProps) {
  const gridTemplateColumns = Object.fromEntries(
    Object.entries(columns).map(([breakpoint, count]) => [
      breakpoint,
      count === 1 ? '1fr' : `repeat(${count}, 1fr)`,
    ])
  );

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns,
        gap: { xs: 2.5, sm: 3, md: 3 },
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    >
      {children}
    </Box>
  );
}

export default LandingCardGrid;
